import { render } from "./DeliveryInstructionArea.vue?vue&type=template&id=4de0416d&scoped=true"
import script from "./DeliveryInstructionArea.vue?vue&type=script&lang=js"
export * from "./DeliveryInstructionArea.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=4de0416d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4de0416d"]])

export default __exports__